<template>
    <client-page>
        <!-- S: 서브 비주얼 -->
        <template #subHead>
            <sub-visual title="유통데이터 활용 경진대회 주요자료" src="/images/sub/sub-visual-circulation.jpg"></sub-visual>
        </template>
        <!-- E: 서브 비주얼 -->

        <page-section class="page-section--first page-section--last">
            <div class="tab-wrap" data-aos="fade-right" data-aos-delay="100">
                <u-tabs>
                    <u-tab v-for="(category, index) in categories" :key="index" @click="(filter.category = category), search(true)">
                        {{ category }}
                    </u-tab>
                </u-tabs>
            </div>

            <v-divider class="grey darken-4 mb-20px mb-md-32px" style="border-width: 2px 0 0;" />
            <v-row data-aos="fade-up" data-aos-delay="200">
                <v-col v-for="data in datas" :key="data._id" cols="6" md="4">
                    <card-board :to="`/circulation/data/${data._id}`" :chip="data?.awardName" :title="data?.subject" :teamName="data?.name" :view="String(data?.viewCount)"> </card-board>
                </v-col>
            </v-row>

            <div class="v-pagination-wrap">
                <v-pagination v-model="page" :length="pageCount" total-visible="11" @input="search(true)" />
            </div>
        </page-section>
    </client-page>
</template>

<script>
import api from "@/api";

import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import PageSection from "@/components/dumb/page-section.vue";
import UTabs from "@/components/dumb/u-tabs.vue";
import UTab from "@/components/dumb/u-tab.vue";
import CardBoard from "@/components/dumb/card-board.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        PageSection,
        UTabs,
        UTab,
        CardBoard
    },
    data() {
        return {

            filter: {
                category: this.$route.query.category || null,
            },

            page: +this.$route.query.page || 1,
            pageCount: 0, // 페이징 분할 크기
            limit: 15, // n개 만큼 게시글 가져오기
            summary: { totalCount: 0 },
            datas: [],

            categories: [ "전체" ]
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            let { setting } = await api.v1.setting.get();
            this.categories.push(...setting.datas.categories);
            await this.search(false);
        },

        async search(routable = false) {
            // 페이징 or 필터 변경시 라우터 기록 -> 뒤로가기시 이전 라우터로 복귀
            if (routable) {
                this.$router.push({
                    query: { ...this.filter, page: this.page },
                });
            }

            let { summary, datas } = await api.v1.circulation.datas.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit,
                },
                params: this.filter,
            });

            this.summary = summary;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
            this.datas = datas;
        },
    },
};
</script>
